import { f as SLASH } from './request.constants-deb285e0.js';
import { L as LOCALE_REGEXP, P as PRODUCT_RANGE_SEGMENT, I as ID_REGEXP } from './constants-afaa9f0a.js';

let selectedFilters;
let selectedSections;
const parseFilters = (filters = []) => {
  return filters.map((filter) => {
    const { filterRefinements: items = [], isCategory, characteristicName: title } = filter;
    const selectedItems = items.filter(({ checked }) => checked).map(({ label }) => label);
    const subItems = parseFilters(filter.subcharacteristics);
    if (!isCategory) {
      selectedFilters = [...selectedFilters, ...selectedItems];
      if (selectedItems.length > 0 && !selectedSections.includes(title)) {
        selectedSections.push(title);
      }
    }
    return {
      title,
      isCategory,
      subItems,
      selectedItems,
      items,
    };
  });
};
const parseRangeFilters = (filtersData = []) => {
  selectedFilters = [];
  selectedSections = [];
  const filters = parseFilters(filtersData);
  const filtersCount = selectedFilters.length;
  return {
    filters,
    isSelected: filtersCount > 0,
    filtersCount,
    selectedSectionsCount: selectedSections.length,
  };
};
const getSeoUrl = (categoryFilterRefinements, navigationState) => {
  var _a;
  let filterItem = categoryFilterRefinements.find((item) => item.navigationState === navigationState.toLowerCase());
  if (!filterItem) {
    filterItem = categoryFilterRefinements.find((item) => item.checked);
  }
  return (_a = filterItem === null || filterItem === void 0 ? void 0 : filterItem.seoUrl.replace(LOCALE_REGEXP, '').replace(SLASH, '')) !== null && _a !== void 0 ? _a : '';
};
const getNodeIds = (seoUrl) => {
  let nodeIds = '';
  if (seoUrl) {
    const splittedUrl = seoUrl.split(PRODUCT_RANGE_SEGMENT);
    if (splittedUrl.length > 1) {
      const idList = splittedUrl[1].split(SLASH);
      for (let i = 1; i < idList.length; i += 1) {
        const nodeId = idList[i].match(ID_REGEXP);
        if (nodeId)
          nodeIds = `${nodeIds}${nodeId}${SLASH}`;
      }
    }
  }
  return nodeIds;
};

export { getSeoUrl as a, getNodeIds as g, parseRangeFilters as p };
